<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">Track Confirmation</h4>
  <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onClose()" title="Close"></i>
</div>
<div class="modal-body">
  <p>
    {{ data.message }}
  </p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="onClose()">No</button>
  <button type="button" class="btn btn-primary" (click)='onSubmit()'>
    Yes
  </button>
</div>
